/**
 * No teacher names or avatars are shown until there are real, verified buyers.
 * Badge colours stay here for the Testimonials component.
 */
export const avatarColors = ['bg-coral', 'bg-teal', 'bg-indigo', 'bg-amber', 'bg-coral', 'bg-teal']
